<template>
  <section>
    <b-field :label="theme">
      <b-datepicker
        v-model="computedValue"
        ref="datepicker"
        placeholder="Click to select a date"
        :min-date="minDate"
        :max-date="maxDate"
        :events="events"
        :mobileNative="false"
        :nearby-selectable-month-days="true"
        indicators="bars"
        range
      >
        <template>
          <div
            class="m-0 has-text-centered"
            v-if="
              flightDates.length > 0 ||
                carDates.length > 0 ||
                hotelDates.length > 0
            "
          >
            <h4 class="is-size-7 has-text-grey mb-3">
              Use Existing Travel Dates
            </h4>
            <div
              class="is-inline-block mr-3 is-clickable box p-2"
              v-if="flightDates.length > 0"
              @click="useSegmentDates(flightDates)"
            >
              <span class="has-background-info dot mr-1"></span>
              <span class="is-inline-block">Flight dates</span>
              <br />
              <span class="has-text-grey is-size-7">{{
                flightDatesDisplay
              }}</span>
            </div>
            <div
              class="is-inline-block is-clickable box p-2"
              v-if="carDates.length > 0"
              @click="useSegmentDates(carDates)"
            >
              <span class="has-background-success dot mr-1"></span>
              <span>Car dates</span>
              <br />
              <span class="has-text-grey is-size-7">{{
                carDatesDisplay
              }}</span>
            </div>
          </div>
        </template>
      </b-datepicker>
    </b-field>
  </section>
</template>

<script>
let moment = require("moment");

export default {
  props: {
    value: {},
    theme: {
      type: String,
      default: "",
    },
    segmentType: String,
  },
  methods: {
    useSegmentDates(dates) {
      this.$emit("input", dates);
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    events() {
      var allSelectedDates = this.$store.getters[
        "bookTravel/getAllSelectedDates"
      ];

      var filteredSelectedDates = allSelectedDates.filter((singleDate) => {
        return singleDate.segmentType != this.segmentType;
      });

      return filteredSelectedDates;
    },
    minDate() {
      // Look for a date for this segment type that is before this dateIndex
      if (this.localMinDate) {
        return this.localMinDate;
      }

      return this.absoluteMinDate;
    },
    maxDate() {
      return this.absoluteMaxDate;
    },
    absoluteMinDate() {
      var date = this.$date.getFirstTravelDate();
      return moment(date).toDate();
    },
    absoluteMaxDate() {
      var date = this.$date.getLastTravelDate();
      return moment(date).toDate();
    },
    localMinDate() {
      var previousDateIndex = this.dateIndex - 1;
      if (
        this.dateIndex > 0 &&
        this.currentSegmentDates &&
        this.currentSegmentDates[previousDateIndex]
      ) {
        return this.currentSegmentDates[previousDateIndex];
      }

      return null;
    },
    flightDates() {
      return this.$store.getters["bookTravel/getSelectedFlightDates"];
    },
    flightDatesDisplay() {
      var dates = this.flightDates;

      var displayMessageParts = [];
      var displayMessage = "";

      for (let date of dates) {
        displayMessageParts.push(moment(date).format("MMM D"));
      }

      if (displayMessageParts.length > 2) {
        displayMessage = displayMessageParts.join(", ");
      } else {
        displayMessage = displayMessageParts.join(" - ");
      }

      return displayMessage;
    },
    carDates() {
      return this.$store.getters["bookTravel/getSelectedCarDates"];
    },
    carDatesDisplay() {
      var dates = this.carDates;

      var displayMessageParts = [];

      for (let date of dates) {
        displayMessageParts.push(moment(date).format("MMM D"));
      }

      return displayMessageParts.join(" - ");
    },
    hotelDates() {
      return this.$store.getters["bookTravel/getSelectedHotelDates"];
    },
    hotelDatesDisplay() {
      var dates = this.hotelDates;

      var displayMessageParts = [];

      for (let date of dates) {
        displayMessageParts.push(moment(date).format("MMM D"));
      }

      return displayMessageParts.join(" - ");
    },
    currentSegmentDates() {
      var segmentVariableName = this.segmentType + "DatesSearched";
      var dates = this[segmentVariableName];

      return dates;
    },
    firstSelectedTravelDate() {
      var firstSelectedTravelDate = this.$store.getters[
        "bookTravel/getFirstSelectedDate"
      ];

      return firstSelectedTravelDate;
    },
  },
};
</script>

<style scoped>
.dot {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  position: relative;
}
</style>
